<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8 lg8>
          <v-card v-if="provisionedPhoneNumbers" class="elevation-2">
            <v-card-title class="blue white--text">Select phone number</v-card-title>
            <v-list v-for="number in provisionedPhoneNumbers" :key="number.phoneNumber">
              <v-list-item @click="routeToSegment(number.phoneNumber)">
                <v-list-item-title>
                  {{number.friendlyName}} {{number.phoneNumber}}
                </v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>
<script>
import {collection, getDocs} from "firebase/firestore";
export default {
  data: () => ({
    provisionedPhoneNumbers: undefined,
  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    filteredList () {
      if(this.sortedSegments.length !== 0) {
        return this.sortedSegments.filter((user) => {
          return user.name.toLowerCase().match(this.searchSegment.toLowerCase())
        })
      } else return []
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  created () {
    let db = this.$store.state.db
    let numbersRef = getDocs(collection(db, 'users', this.user.uid + '/provisionedNumbers'))
    return numbersRef
        .then (numbers => {
          let numbersList = []
          let phoneNumbersOnly = []
          numbers.forEach (number => {
            numbersList.push(number.data())
            phoneNumbersOnly.push(number.data().friendlyName)
          })
          this.provisionedPhoneNumbers = numbersList
          console.log(numbersList)
        })
  },
  methods: {
    routeToSegment (phoneNumber) {
     let uid = this.user.uid
     this.$router.push('/segments/' + uid + '/' + phoneNumber)
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }

}
</script>

